module.exports = __webpack_public_path__ + "img/ewm3.4b8b2c8a.jpg";